webpackJsonp([1],{

/***/ "5W1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5h6Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GkQf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KR55":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var object_keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.js
var vuedraggable = __webpack_require__("DAYN");
var vuedraggable_default = /*#__PURE__*/__webpack_require__.n(vuedraggable);

// CONCATENATED MODULE: ./src/event-bus.js

var bus = new vue_esm["a" /* default */]();
// EXTERNAL MODULE: ./node_modules/material-design-icons/iconfont/material-icons.css
var material_icons = __webpack_require__("uTBe");
var material_icons_default = /*#__PURE__*/__webpack_require__.n(material_icons);

// EXTERNAL MODULE: ./node_modules/@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.js
var mapbox_gl_draw = __webpack_require__("uZ0T");
var mapbox_gl_draw_default = /*#__PURE__*/__webpack_require__.n(mapbox_gl_draw);

// EXTERNAL MODULE: ./node_modules/@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css
var dist_mapbox_gl_draw = __webpack_require__("5h6Y");
var dist_mapbox_gl_draw_default = /*#__PURE__*/__webpack_require__.n(dist_mapbox_gl_draw);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./src/components/v-welcome.js


/* harmony default export */ var v_welcome = ({
  data: function data() {
    return {
      welcome: true,
      dialog: true
    };
  },

  watch: {
    dialog: {
      handler: function handler(dialog) {
        this.dialog = dialog;
        bus.$emit('change-dialog', dialog);
      },
      deep: true
    }
  },

  methods: {
    openTutorial: function openTutorial() {
      document.getElementById("welcome").style.display = "none";
      document.getElementById("tutorial1").style.display = "block";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b706a32","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VWelcome.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"600px","max-height":"400px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"id":"welcome","light":""}},[_c('v-card-media',{attrs:{"src":"https://images0.persgroep.net/rcs/2jlsSDCpSbg65v3o-pUfkL_sJVA/diocontent/70318024/_crop/1/65/899/508/_fitwidth/763?appId=e9b4e2a1869038ffcaf318a6d1463b0b&quality=0.8","height":"200px"}}),_vm._v(" "),_c('v-card-title',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("\r\n        Hallo allemaal\r\n      ")]),_vm._v(" "),_c('div',[_vm._v("Wat fijn dat je er bent! Ben je voor het eerst hier? Of ben je al Bekend? ")]),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"round":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog=false}}},[_vm._v("Al bekend")]),_vm._v(" "),_c('v-btn',{attrs:{"round":"","color":"primary","dark":""},nativeOn:{"click":function($event){_vm.openTutorial()}}},[_vm._v("Eerste keer")])],1)])],1),_vm._v(" "),_c('v-card',{attrs:{"id":"tutorial1","light":""}},[_c('v-card-media',{attrs:{"src":"https://images0.persgroep.net/rcs/2jlsSDCpSbg65v3o-pUfkL_sJVA/diocontent/70318024/_crop/1/65/899/508/_fitwidth/763?appId=e9b4e2a1869038ffcaf318a6d1463b0b&quality=0.8","height":"200px"}}),_vm._v(" "),_c('v-card-title',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("\r\n      Tutorial\r\n    ")]),_vm._v(" "),_c('div',[_vm._v("This is a short introduction to the sandmotor viewer.")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog=false}}},[_vm._v("Close")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var VWelcome = (esExports);
// CONCATENATED MODULE: ./src/components/VWelcome.vue
function injectStyle (ssrContext) {
  __webpack_require__("KR55")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b706a32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  v_welcome,
  VWelcome,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_VWelcome = (Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/remarkable/index.js
var remarkable = __webpack_require__("OVoi");
var remarkable_default = /*#__PURE__*/__webpack_require__.n(remarkable);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./src/components/layer-control.js







/* harmony default export */ var layer_control = ({
  name: 'layer-control',
  props: {
    layers: {
      type: Array,
      required: true
    },
    map: {
      type: Object
    }
  },
  data: function data() {
    return {
      btnInfo: null
    };
  },
  mounted: function mounted() {},

  watch: {
    // Watch "layers". This is a switch, which can toggle a layer on or off
    // When toggled, this watcher will activate the toggleLayers function.
    layers: {
      handler: function handler(layers) {
        this.toggleLayers();
        this.sortLayers();
      },
      deep: true
    }
  },
  computed: {
    computedList: {
      get: function get() {
        return this.layers;
      },
      set: function set(layers) {
        bus.$emit('select-layers', layers);
      }
    }
  },
  methods: {
    sortLayers: function sortLayers() {
      for (var i = this.layers.length - 2; i >= 0; --i) {
        if (this.layers[i].data !== undefined) {
          for (var thislayer = 0; thislayer < this.layers[i].data.length; ++thislayer) {
            this.map.moveLayer(this.layers[i].data[thislayer].id);
          }
        } else {
          this.map.moveLayer(this.layers[i].id);
        }
      }
    },
    addInfoCard: function addInfoCard(layerName) {
      // make unique ID
      var now = moment_default()(new Date()).unix();
      var layerID = layerName + "_" + now;

      var md = new remarkable_default.a();
      // launch a vcard with wiki info
      fetch(bus.$emit('add-card', layerID)).then(function (resp) {
        var div = document.getElementById("plot_" + layerID);
        div.style.width = "500px";
        div.style.heigth = "300px";
        fetch('http://raw.githubusercontent.com/wiki/openearth/sandmotor-viewer/' + layerName + '.md', {
          mode: 'cors'
        }).then(function (data) {
          return data.text();
        }).then(function (data) {
          div.innerHTML = md.render(data);
        });
      });
    },
    toggleLayers: function toggleLayers() {
      var _this = this;

      if (lodash_default.a.isNil(this.map)) {
        return;
      }
      // Function to toggle the visibility of the layers.
      lodash_default.a.each(this.layers, function (layer) {
        var vis = "none";
        if (layer.active) {
          vis = "visible";
        }

        if (layer.type === 'group') {
          lodash_default.a.each(layer.data, function (sublayer) {
            _this.map.setLayoutProperty(sublayer.id, "visibility", vis);
          });
        } else {
          _this.map.setLayoutProperty(layer.id, "visibility", vis);
        }
      });
    }
  },
  components: {
    draggable: vuedraggable_default.a
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c401a838","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LayerControl.vue
var LayerControl_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layer-control"},[_c('draggable',{staticClass:"draggable",on:{"start":function($event){_vm.drag=true},"end":function($event){_vm.drag=false}},model:{value:(_vm.computedList),callback:function ($$v) {_vm.computedList=$$v},expression:"computedList"}},_vm._l((_vm.layers),function(layer){return _c('v-list',{key:layer.id,attrs:{"dense":"","pt-0":""}},[_c('v-list-tile',{attrs:{"id":"list-tile"}},[_c('v-list-tile-action',[_c('v-switch',{model:{value:(layer.active),callback:function ($$v) {_vm.$set(layer, "active", $$v)},expression:"layer.active"}})],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(layer.name))]),_vm._v(" "),_c('v-list-tile-action',{staticStyle:{"display":"-webkit-box"}},[(layer.clickable)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\r\n              fa-area-chart\r\n            ")]),_vm._v(" "),_c('span',[_vm._v("This layer is clickable and a card with a graph will appear.")])],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticStyle:{"min-width":"30px"},attrs:{"slot":"activator","small":""},nativeOn:{"click":function($event){_vm.addInfoCard(layer.id)}},slot:"activator"},[_c('v-icon',[_vm._v("fa-question")])],1),_vm._v(" "),_c('span',[_vm._v("A card will appear with more information about this layer.")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"bar-wrapper"},[(layer.css)?_c('div',{staticClass:"bar",style:(layer.css)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bartext"},[_vm._v(_vm._s(layer.range)+" "),_c('span',{staticClass:"barspan"})]),_vm._v(" "),_c('div',{staticClass:"information",domProps:{"innerHTML":_vm._s(layer.info)}},[_vm._v(_vm._s(layer.info)+"\r\n        ")])])],1)}))],1)}
var LayerControl_staticRenderFns = []
var LayerControl_esExports = { render: LayerControl_render, staticRenderFns: LayerControl_staticRenderFns }
/* harmony default export */ var LayerControl = (LayerControl_esExports);
// CONCATENATED MODULE: ./src/components/LayerControl.vue
function LayerControl_injectStyle (ssrContext) {
  __webpack_require__("uS3p")
}
var LayerControl_normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var LayerControl___vue_template_functional__ = false
/* styles */
var LayerControl___vue_styles__ = LayerControl_injectStyle
/* scopeId */
var LayerControl___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LayerControl___vue_module_identifier__ = null
var LayerControl_Component = LayerControl_normalizeComponent(
  layer_control,
  LayerControl,
  LayerControl___vue_template_functional__,
  LayerControl___vue_styles__,
  LayerControl___vue_scopeId__,
  LayerControl___vue_module_identifier__
)

/* harmony default export */ var components_LayerControl = (LayerControl_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./src/components/morphology-canvas.js





/* harmony default export */ var morphology_canvas = ({
  name: 'morphology-canvas',
  data: function data() {
    return {
      baseUrl: 'https://s3-eu-west-1.amazonaws.com/deltares-opendata/zandmotor/morphology/jetski',
      meta: null,
      map: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    fetch(this.baseUrl + '/meta.json').then(function (resp) {
      return resp.json();
    }).then(function (json) {
      _this.meta = json;
      vue_esm["a" /* default */].nextTick(function () {
        // after we render everything lookup all elements
        lodash_default.a.each(_this.meta, function (item, i) {

          var selector = '#morphology-' + i;
          var el = _this.$el.querySelector(selector);
          var children = el.children;

          var _children = slicedToArray_default()(children, 3),
              video = _children[0],
              source = _children[1],
              dest = _children[2];

          item.width = 500;
          item.height = 625;
          item.video = video;
          item.source = source;
          item.dest = dest;
          item.ctxSrc = source.getContext('2d');
          item.ctxDest = dest.getContext('2d');

          item.id = 'morphology-canvas-' + i;

          var layer = {
            name: "Jetski-" + i,
            active: false,
            visibility: "none",
            id: item.id,
            type: 'raster',
            icon: 'filter_drama',
            source: {
              type: 'canvas',
              animate: true,
              canvas: item.id,
              coordinates: [[item.extent[0], item.extent[1]], [item.extent[2], item.extent[1]], [item.extent[2], item.extent[3]], [item.extent[0], item.extent[3]]]
            },
            paint: {}
          };
          item.layer = layer;
          console.log('layer', layer);
          _this.publishLayers();
        });
        _this.animate();
      });
    });
  },

  methods: {
    deferredMountedTo: function deferredMountedTo(map) {
      this.map = map;
      this.publishLayers();
    },
    animate: function animate() {
      requestAnimationFrame(this.animate);
      lodash_default.a.each(this.meta, function (item) {
        // render to canvas
        item.ctxSrc.drawImage(item.video, 0, 0, item.width, item.height * 2);
        // get frame into memory
        var nPixels = item.width * item.height;
        var frame = item.ctxSrc.getImageData(0, 0, item.width, item.height * 2);
        for (var i = 0; i < nPixels; i++) {
          var r = frame.data[i * 4 + 0];
          var g = frame.data[i * 4 + 1];
          var b = frame.data[i * 4 + 2];
          var a = frame.data[i * 4 + nPixels * 4] > 100 ? 0 : 255;
          frame.data[i * 4 + 3] = a;
        };
        item.ctxDest.putImageData(frame, 0, 0);
      });
    },
    publishLayers: function publishLayers() {
      var _this2 = this;

      if (this.map == null) {
        // map is not set yet
        return;
      }
      lodash_default.a.each(this.meta, function (item) {
        _this2.map.addLayer(item.layer);
        bus.$emit('add-layer', item.layer);
      });
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d430a7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MorphologyCanvas.vue
var MorphologyCanvas_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hidden"},_vm._l((_vm.meta),function(item,index){return _c('div',{attrs:{"id":'morphology-' + index}},[_c('video',{staticClass:"hidden",attrs:{"width":500,"height":1250,"src":_vm.baseUrl + '/' + item.mp4,"autoplay":"","loop":"","crossorigin":"anonymous"}}),_vm._v(" "),_c('canvas',{staticClass:"source hidden",attrs:{"width":500,"height":1250}}),_vm._v(" "),_c('canvas',{staticClass:"dest",attrs:{"width":500,"height":625,"id":'morphology-canvas-' + index}})])}))}
var MorphologyCanvas_staticRenderFns = []
var MorphologyCanvas_esExports = { render: MorphologyCanvas_render, staticRenderFns: MorphologyCanvas_staticRenderFns }
/* harmony default export */ var MorphologyCanvas = (MorphologyCanvas_esExports);
// CONCATENATED MODULE: ./src/components/MorphologyCanvas.vue
function MorphologyCanvas_injectStyle (ssrContext) {
  __webpack_require__("GkQf")
}
var MorphologyCanvas_normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var MorphologyCanvas___vue_template_functional__ = false
/* styles */
var MorphologyCanvas___vue_styles__ = MorphologyCanvas_injectStyle
/* scopeId */
var MorphologyCanvas___vue_scopeId__ = "data-v-5d430a7e"
/* moduleIdentifier (server only) */
var MorphologyCanvas___vue_module_identifier__ = null
var MorphologyCanvas_Component = MorphologyCanvas_normalizeComponent(
  morphology_canvas,
  MorphologyCanvas,
  MorphologyCanvas___vue_template_functional__,
  MorphologyCanvas___vue_styles__,
  MorphologyCanvas___vue_scopeId__,
  MorphologyCanvas___vue_module_identifier__
)

/* harmony default export */ var components_MorphologyCanvas = (MorphologyCanvas_Component.exports);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/ion-rangeslider/js/ion.rangeSlider.js
var ion_rangeSlider = __webpack_require__("w+/p");
var ion_rangeSlider_default = /*#__PURE__*/__webpack_require__.n(ion_rangeSlider);

// EXTERNAL MODULE: ./node_modules/font-awesome/css/font-awesome.css
var font_awesome = __webpack_require__("5W1q");
var font_awesome_default = /*#__PURE__*/__webpack_require__.n(font_awesome);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./src/components/time-slider.js







var DAY_FORMAT = 'Y-MM-DD';

/* harmony default export */ var time_slider = ({
  name: "time-slider",
  props: {
    showPlay: {
      type: Boolean,
      default: true
    },
    // the maximum extent for this slider
    extent: {
      type: Array,
      default: function _default() {
        var now = moment_default()();
        var then = moment_default()("20110301", "YYYYMMDD");
        return [then, now];
      }
    }
  },
  data: function data() {
    return {
      configDialog: false,
      startDateMenu: false,
      endDateMenu: false,
      // by default use the full extent
      startDate: this.extent[0].format(DAY_FORMAT),
      endDate: this.extent[1].format(DAY_FORMAT),
      // duration of a loop
      loopDuration: 20,
      maxFps: 10,
      // last timestep (for syncing rate)
      last: null,
      loop: true,
      state: 'paused',
      slider: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    vue_esm["a" /* default */].nextTick(function () {
      var input = _this.$el.querySelector("input.slider");
      jquery_default()(input).ionRangeSlider({
        type: "double",
        drag_interval: true,
        min: 0,
        max: 1,
        // not sure how to avoid steps, now use 1000 steps
        step: 0.001,
        grid: false,
        hide_min_max: true,
        onFinish: function onFinish(val) {
          _this.$emit('time-extent-update', _this.currentExtent);
        },
        onUpdate: function onUpdate(val) {
          _this.$emit('time-extent-update', _this.currentExtent);
        },
        prettify: function prettify(val) {
          return _this.dateFormat(val);
        }
      });
      _this.slider = jquery_default()(input).data("ionRangeSlider");
      _this.step();
    });
  },

  watch: {
    extent: function extent(val) {
      if (this.slider.dragging) {
        return;
      }
      // always slide from 0 to 1
      this.slider.update({
        from: 0,
        to: 1
      });
    }
  },
  methods: {
    pause: function pause() {
      this.state = 'paused';
    },
    play: function play() {
      this.last = performance.now();
      this.state = 'playing';
    },
    step: function step(now) {
      // request the next step (yes you can call this function now, does not matter)
      requestAnimationFrame(this.step);
      // first update, when this.last is still null, set value and return
      if (!this.last) {
        this.last = now;
        return;
      }
      // now we can just return if we are not playing (will result in a regular poll for playing)
      if (this.state !== 'playing') {
        return;
      }
      // elapsed time in seconds
      var elapsed = (now - this.last) / 1000;
      // seconds per frame did not elapse, we're done
      if (elapsed < 1 / this.maxFps) {
        // this keeps the number of events low (otherwise you get 60 events per second)
        return;
      }
      // elapsed fraction
      var frac = elapsed / this.loopDuration;
      // update with fraction
      var val = {
        from: lodash_default.a.clamp(this.slider.result.from + frac, 0, 1),
        to: lodash_default.a.clamp(this.slider.result.to + frac, 0, 1)
        // TODO: google earth uses a smarter loop,
        // it keeps track of the diff somehow
        // we reached the end, loop
      };if (val.to == 1) {
        if (this.loop) {
          val.to = val.to - val.from;
          val.from = 0;
        } else {
          // stop updating
          return;
        }
      }
      // apply it to the slider (fires update event)
      this.slider.update(val);
      // remember current time
      this.last = now;
    },
    dateByFraction: function dateByFraction(fraction) {
      // miliseconds diff
      var start = moment_default()(this.startDate);
      var end = moment_default()(this.endDate);
      // positive number of miliseconds
      var diff = end.diff(start);
      var time = start.clone().add(diff * fraction, 'ms');
      return time;
    },
    dateFormat: function dateFormat(fraction) {
      return this.dateByFraction(fraction).format(DAY_FORMAT);
    },
    deferredMountedTo: function deferredMountedTo(map) {
      // Used when nested in a Leaflet or Mapbox
    }
  },
  computed: {
    currentTime: function currentTime() {
      return this.dateByFraction(this.slider.result.to);
    },
    currentExtent: function currentExtent() {
      return [this.dateByFraction(this.slider.result.from), this.dateByFraction(this.slider.result.to)];
    },
    allowedDates: function allowedDates() {
      // return allowed dates, based on extent
      return {
        min: this.extent[0].format(DAY_FORMAT),
        max: this.extent[1].format(DAY_FORMAT)
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-674f5e0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimeSlider.vue
var TimeSlider_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"time-slider",attrs:{"color":"white","floating":"","dense":"","role":"slider"}},[_c('div',{staticClass:"time-slider-wrapper"},[_c('input',{staticClass:"slider",attrs:{"type":"text","name":"slider","value":""}})]),_vm._v(" "),(_vm.showPlay)?_c('v-btn-toggle',{attrs:{"mandatory":""},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}},[_c('v-btn',{attrs:{"value":"playing","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.play($event)}}},[_c('v-icon',[_vm._v("fa-play")])],1),_vm._v(" "),_c('v-btn',{attrs:{"value":"paused","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.pause($event)}}},[_c('v-icon',[_vm._v("fa-pause")])],1)],1):_vm._e(),_vm._v(" "),(_vm.showPlay)?_c('v-btn-toggle',{model:{value:(_vm.loop),callback:function ($$v) {_vm.loop=$$v},expression:"loop"}},[_c('v-btn',{attrs:{"value":true,"flat":""}},[_c('v-icon',[_vm._v("fa-repeat")])],1)],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.configDialog = true}}},[_c('v-icon',[_vm._v("fa-gear")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.configDialog),callback:function ($$v) {_vm.configDialog=$$v},expression:"configDialog"}},[_c('v-card',[_c('v-card-text',[_c('v-menu',{ref:"startDateMenu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","return-value":_vm.startDate},on:{"update:returnValue":function($event){_vm.startDate=$event}},model:{value:(_vm.startDateMenu),callback:function ($$v) {_vm.startDateMenu=$$v},expression:"startDateMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Picker in menu","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"allowed-dates":_vm.allowedDates,"no-title":"","scrollable":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1),_vm._v(" "),_c('v-menu',{ref:"endDateMenu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","return-value":_vm.endDate},on:{"update:returnValue":function($event){_vm.endDate=$event}},model:{value:(_vm.endDateMenu),callback:function ($$v) {_vm.endDateMenu=$$v},expression:"endDateMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Picker in menu","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"allowed-dates":_vm.allowedDates,"no-title":"","scrollable":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.configDialog=false}}},[_vm._v("Close")])],1)],1)],1)],1)}
var TimeSlider_staticRenderFns = []
var TimeSlider_esExports = { render: TimeSlider_render, staticRenderFns: TimeSlider_staticRenderFns }
/* harmony default export */ var TimeSlider = (TimeSlider_esExports);
// CONCATENATED MODULE: ./src/components/TimeSlider.vue
function TimeSlider_injectStyle (ssrContext) {
  __webpack_require__("k7bT")
}
var TimeSlider_normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var TimeSlider___vue_template_functional__ = false
/* styles */
var TimeSlider___vue_styles__ = TimeSlider_injectStyle
/* scopeId */
var TimeSlider___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TimeSlider___vue_module_identifier__ = null
var TimeSlider_Component = TimeSlider_normalizeComponent(
  time_slider,
  TimeSlider,
  TimeSlider___vue_template_functional__,
  TimeSlider___vue_styles__,
  TimeSlider___vue_scopeId__,
  TimeSlider___vue_module_identifier__
)

/* harmony default export */ var components_TimeSlider = (TimeSlider_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue2mapbox-gl/dist/vue2mapbox-gl.js
var vue2mapbox_gl = __webpack_require__("5BM0");
var vue2mapbox_gl_default = /*#__PURE__*/__webpack_require__.n(vue2mapbox_gl);

// CONCATENATED MODULE: ./src/components/map-draw.js








var map_draw_DAY_FORMAT = 'Y-MM-DD';

vue_esm["a" /* default */].use(vue2mapbox_gl_default.a);
var draw = new mapbox_gl_draw({
  displayControlsDefault: false,
  controls: {
    line_string: true,
    trash: true
  }
});

var map_draw_colors = ['#ffffff', '#e6e6ff', '#ccccff', '#b3b3ff', '#9999ff', '#8080ff', '#6666ff', '#4d4dff', '#3333ff', '#1a1aff', '#0000ff', '#0000e6', '#0000cc', '#0000b3', '#000099', '#000080', '#000066', '#00004d', '#000033', '#00001a', '#000000'];
var map_draw_draws = [];

function DrawControls(map, draws, beginDate, endDate, dataset) {
  _.each(dataset, function (set) {
    if (set === "bathymetry_lidar") {
      beginDate = moment_default()("2001-01-01");
      endDate = moment_default()("2018-01-01");
    }
    var profile = download_raster_profile(draws, set, 20, beginDate, endDate);
  });
}

function download_raster_profile(regions, dataset, scale, begin_date, end_date) {
  _.each(regions, function (region) {
    var SERVER_URL = 'http://hydro-engine.appspot.com';
    // var SERVER_URL = 'http://localhost:8080'
    var data = {
      'polyline': region,
      "dataset": dataset,
      "begin_date": begin_date,
      "end_date": end_date,
      'scale': scale
    };
    var myHeaders = new Headers();
    var profile = fetch(SERVER_URL + '/get_raster_profile', {
      method: "POST",
      body: stringify_default()(data),
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      return res.json();
    }).then(function (profile_data) {
      bokehplot(profile_data, data, stringify_default()(region) + '_' + dataset);
      return profile_data;
    });
    return profile;
  });
};

function bokehplot(profile_data, data, div_id) {
  var div = document.getElementById("plot_" + div_id);

  // div.innerHTML = ""; // clear div
  // console.log('profile_data', JSON.stringify(profile_data), profile_data.type)
  var plt = Bokeh.Plotting;
  var tools = "pan,crosshair,wheel_zoom,box_zoom,reset,save";
  var begin = data.begin_date;
  var end = data.end_date;
  var source = new Bokeh.GeoJSONDataSource({
    geojson: stringify_default()(profile_data)
  });

  if (Bokeh.index[div_id] != undefined) {
    var plot = Bokeh.index[div_id].model;
    var color = map_draw_colors[Bokeh.index[div_id].model._legend.attributes.items.length];
  } else {
    var plot = new plt.figure({
      name: div_id,
      id: div_id,
      title: data.dataset,
      tools: tools,
      width: 800,
      height: 350,
      background_fill_color: "#F2F2F7",
      x_axis_label: 'Distance w.r.t. first coordinate [m]',
      y_axis_label: 'Elevation [m, NAP]'
    });
    var color = map_draw_colors[0];
  }

  plot.line({
    field: "distance"
  }, {
    field: "b1_mean"
  }, {
    source: source,
    legend: begin.format(map_draw_DAY_FORMAT) + ' to ' + end.format(map_draw_DAY_FORMAT),
    line_width: 2,
    line_color: color
  });
  if (Bokeh.index[div_id] == undefined) {
    var doc = new Bokeh.Document();
    doc.add_root(plot);
    Bokeh.embed.add_document_standalone(doc, div);
  }
}


// CONCATENATED MODULE: ./src/components/jetski.js




var jetski_jetski = undefined;

function updateJetski(map, layers) {
  var begin_date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "2010-01-01";
  var end_date = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "2018-01-01";

  var json_data = {
    "dataset": "jetski",
    "begin_date": begin_date,
    "end_date": end_date
  };
  get_images_urls(json_data, map, layers);
}

function get_images_urls(json_data, map, layers) {
  var SERVER_URL = 'https://hydro-engine.appspot.com';
  // var SERVER_URL = 'http://localhost:8080'
  var image_urls = fetch(SERVER_URL + '/get_bathymetry', {
    method: "POST",
    body: stringify_default()(json_data),
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    return res.json();
  }).then(function (image_data) {
    updateLayers(image_data, map, layers);
    return image_data;
  });
  return image_urls;
}

function updateLayers(url, map, layers) {
  jetski = layers.find(function (item) {
    return item.id === "Jetski";
  });
  if (jetski === undefined) {
    var jetski = {
      "name": "Jetski [m, NAP]",
      "active": false,
      "icon": "landscape",
      "data": [],
      "type": "group",
      "id": "Jetski",
      "range": "-12 7",
      "z-order": 0,
      "clickable": false,
      "css": "background: linear-gradient(to right, #000033,#000037,#00003a,#00003e, \
          #000042,#000045,#000049,#00004d,#000050,#000054,#000057,#00005b,#00005f,\
          #000062,#000066,#010268,#03036a,#04056c,#05076e,#070971,#080a73,#0a0c75,\
          #0b0e77,#0c1079,#0e117b,#0f137d,#10157f,#121781,#131884,#141a86,#161c88,\
          #171e8a,#191f8c,#1a218e,#1b2390,#1d2492,#1e2695,#1f2897,#212a99,#222b9b,\
          #242d9d,#252f9f,#2a35a2,#2e3ca6,#3342a9,#3848ac,#3c4faf,#4155b3,#465cb6,\
          #4a62b9,#4f68bc,#546fc0,#5875c3,#5d7bc6,#6282ca,#6688cd,#6b8fd0,#7095d3,\
          #749bd7,#79a2da,#7ea8dd,#82aee0,#87b5e4,#8cbbe7,#90c2ea,#95c8ed,#9acef1,\
          #9ed5f4,#a3dbf7,#a8e1fa,#9edef7,#94daf4,#8ad6f0,#80d2ed,#84cacb,#87c2a9,\
          #8bba87,#8eb166,#92a944,#95a122,#999900,#a4a50b,#afb116,#babd21,#c5c92c,\
          #d0d537,#dce142,#e7ec4d,#f2f857,#f3f658,#f3f359,#f4f15a,#f5ee5b,#f6eb5c,\
          #f6e95d,#f7e65d,#f8e35e,#f9e15f,#fade60,#fadc61,#fbd962,#fcd663,#fdd463,\
          #fdd164,#fecf65,#ffcc66,#fdc861,#fcc55d,#fbc158,#f9be53,#f7ba4f,#f6b64a,\
          #f5b346,#f3af41,#f1ac3c,#f0a838,#efa433,#eda12e,#eb9d2a,#ea9a25,#e99620,\
          #e7931c,#e58f17,#e48b13,#e3880e,#e18409,#df8105,#de7d00);",
      "info": "Zandmotor bathymetric and topographic survey, gridded on 20m grid. The most recent jetski data in the selected period is shown. No data is available after June 2017. <a href='https://data.4tu.nl/repository/uuid:c40da555-3eff-4c3c-89d6-136994a07120'  target='parent'>Data link</a>"
    };
    layers.push(jetski);
    bus.$emit('select-layers', layers);
  } else {
    _.each(jetski.data, function (old) {
      map.removeLayer(old.id);
    });
    jetski.data = [];
  }
  var mapid = url.mapid;
  var token = url.token;
  var mapUrl = getTileUrl(mapid, token);
  var layer = {
    id: mapid,
    name: "jetski",
    type: "raster",
    paint: {
      "raster-opacity": 0.7
    },
    source: {
      type: "raster",
      tiles: [mapUrl],
      tileSize: 256
    }
  };
  map.addLayer(layer);
  jetski.data.push(layer);
}
function getTileUrl(mapId, token) {
  var baseUrl = "https://earthengine.googleapis.com/map";
  var url = [baseUrl, mapId, "{z}", "{x}", "{y}"].join("/");
  url += "?token=" + token;
  return url;
}


// CONCATENATED MODULE: ./src/components/lidar.js



var lidar = undefined;

function AddLidar(map, layers) {
  var begin_date = "2001-01-01";
  var end_date = "2018-01-01";
  var json_data = {
    "dataset": "kustlidar",
    "begin_date": begin_date,
    "end_date": end_date
  };
  lidar_get_images_urls(json_data, map, layers);
}

function lidar_get_images_urls(json_data, map, layers) {
  var SERVER_URL = 'https://hydro-engine.appspot.com';
  // var SERVER_URL = 'http://localhost:8080'
  var image_urls = fetch(SERVER_URL + '/get_bathymetry', {
    method: "POST",
    body: stringify_default()(json_data),
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    return res.json();
  }).then(function (image_data) {
    AddLayers(image_data, map, layers);
    return image_data;
  });
  return image_urls;
}

function AddLayers(url, map, layers) {
  lidar = layers.find(function (item) {
    return item.id === "Lidar";
  });
  if (lidar === undefined) {
    var grouplayer = {
      "name": "LiDAR [m, NAP]",
      "active": false,
      "icon": "fa-plane",
      "data": [],
      "type": "group",
      "range": "-12 7",
      "id": "Lidar",
      "clickable": false,
      "css": "background: linear-gradient(to right, #000033,#000037,#00003a,#00003e, \
          #000042,#000045,#000049,#00004d,#000050,#000054,#000057,#00005b,#00005f,\
          #000062,#000066,#010268,#03036a,#04056c,#05076e,#070971,#080a73,#0a0c75,\
          #0b0e77,#0c1079,#0e117b,#0f137d,#10157f,#121781,#131884,#141a86,#161c88,\
          #171e8a,#191f8c,#1a218e,#1b2390,#1d2492,#1e2695,#1f2897,#212a99,#222b9b,\
          #242d9d,#252f9f,#2a35a2,#2e3ca6,#3342a9,#3848ac,#3c4faf,#4155b3,#465cb6,\
          #4a62b9,#4f68bc,#546fc0,#5875c3,#5d7bc6,#6282ca,#6688cd,#6b8fd0,#7095d3,\
          #749bd7,#79a2da,#7ea8dd,#82aee0,#87b5e4,#8cbbe7,#90c2ea,#95c8ed,#9acef1,\
          #9ed5f4,#a3dbf7,#a8e1fa,#9edef7,#94daf4,#8ad6f0,#80d2ed,#84cacb,#87c2a9,\
          #8bba87,#8eb166,#92a944,#95a122,#999900,#a4a50b,#afb116,#babd21,#c5c92c,\
          #d0d537,#dce142,#e7ec4d,#f2f857,#f3f658,#f3f359,#f4f15a,#f5ee5b,#f6eb5c,\
          #f6e95d,#f7e65d,#f8e35e,#f9e15f,#fade60,#fadc61,#fbd962,#fcd663,#fdd463,\
          #fdd164,#fecf65,#ffcc66,#fdc861,#fcc55d,#fbc158,#f9be53,#f7ba4f,#f6b64a,\
          #f5b346,#f3af41,#f1ac3c,#f0a838,#efa433,#eda12e,#eb9d2a,#ea9a25,#e99620,\
          #e7931c,#e58f17,#e48b13,#e3880e,#e18409,#df8105,#de7d00);",
      "info": "Elevation measurements of the dutch coast done with LIDAR. Single date (begin 2011). <a href='https://data.4tu.nl/repository/uuid:8a8a91bc-e520-4d19-a127-5fd2232cc58e'  target='parent'>Data link</a>"

    };
    layers.push(grouplayer);
    bus.$emit('select-layers', layers);
  } else {
    _.each(lidar.data, function (old) {
      map.removeLayer(old.id);
    });
    lidar.data = [];
  }
  var mapid = url.mapid;
  var token = url.token;
  var mapUrl = lidar_getTileUrl(mapid, token);
  var layer = {
    id: mapid,
    name: "lidar",
    type: "raster",
    active: true,
    layout: {
      visibility: "visible"
    },
    source: {
      type: "raster",
      tiles: [mapUrl],
      tileSize: 256
    },
    paint: {
      "raster-opacity": 0.7
    }
  };
  map.addLayer(layer);
  grouplayer.data.push(layer);
}

function lidar_getTileUrl(mapId, token) {
  var baseUrl = "https://earthengine.googleapis.com/map";
  var url = [baseUrl, mapId, "{z}", "{x}", "{y}"].join("/");
  url += "?token=" + token;
  console.log('url', url);
  return url;
}


// CONCATENATED MODULE: ./src/components/adcp.js




function AddADCP(map, layers) {
  var layer_json = {
    id: 'ADCP',
    active: true,
    visibility: "visible",
    name: 'ADCP',
    type: 'circle',
    icon: 'grain',
    clickable: true,
    'icon-image': 'static/adcp.png',
    source: {
      type: 'geojson',
      data: 'static/adcp_locations.geojson'
    },
    "info": "Measurment from an Acoustic Doppler Current Profilers (ADCP) located at the Sand Motor. <a href='https://data.4tu.nl/repository/uuid:3bc3591b-9d9e-4600-8705-5b7eba6aa3ed' target='parent'>Data link</a>",
    paint: {
      'circle-radius': {
        'base': 1.2,
        'stops': [[12, 2], [22, 180]]
      },
      'circle-color': 'FireBrick'
    }
  };
  map.addLayer(layer_json);
  layers.push(layer_json);
  bus.$emit('select-layers', layers);
}

function filterADCPBy(timeExtent, map) {

  //timeExtent provides 2 moments
  var tstart = timeExtent[0].unix();
  var tend = timeExtent[1].unix();

  var filters = ["all", ['>=', 'tStart', tstart], ['<=', 'tEnd', tend]];
  //map.setFilter('ADCP', filters);
}

function ShowADCPData(point, div_id, timeExtent) {
  // find out which adcp was clicked
  var adcpID = point.properties.ADCPID;
  var url = "https://s3-eu-west-1.amazonaws.com/deltares-opendata/zandmotor/adcp/";
  fetch(url + adcpID + "_data.json").then(function (resp) {
    return resp.json();
  }).then(function (timeseries) {
    adcp_bokehplot('velocity', adcpID, timeseries, point, div_id[0], timeExtent);
    adcp_bokehplot('waterdepth', adcpID, timeseries, point, div_id[1], timeExtent);
  }).catch(function (reason) {
    console.warn(reason);
  });
}

function adcp_bokehplot(mode, adcpID, timeseries, point, div_id, timeExtent) {

  // Check if timeseries is set
  if (timeseries == null) {
    console.log('No timeseries defined');
    return -1;
  }

  var div = document.getElementById(div_id);
  div.innerHTML = ""; // clear div

  // General Bokeh settings
  var plt = Bokeh.Plotting;
  var tools = "pan,crosshair,wheel_zoom,box_zoom,reset,save";

  if (mode == 'velocity') {
    var properties = ['Umean', 'Vmean'];
    var title = adcpID + " depth averaged velocity";
    var ylabel = 'Current velocity [m/s]';
  } else {
    var properties = ['waterdepth'];
    var title = adcpID + " water depth (Scheveningen)";
    var ylabel = 'Water level [m, NAP]';
  }

  var plot = new plt.figure({
    title: title,
    tools: tools,
    width: 1000,
    height: 350,
    x_axis_type: 'datetime',
    x_axis_label: 'Time',
    y_axis_label: ylabel,
    background_fill_color: "#F2F2F7"
  });

  // make line lineplots
  var x = timeseries['time'];

  var colors = ['MidnightBlue', 'ForestGreen'];

  for (var i = 0; i < properties.length; i++) {
    var y = timeseries[properties[i]];
    var source = new Bokeh.ColumnDataSource({
      data: { x: x,
        y: y }
    });

    var line = plot.line({ field: 'x' }, { field: 'y' }, {
      source: source,
      legend: properties[i],
      line_color: colors[i],
      line_width: 2
    });
  }

  plot._legend.location = 'top_left';

  var doc = new Bokeh.Document();
  doc.add_root(plot);
  Bokeh.embed.add_document_standalone(doc, div);

  // filter time
  var plotID = plot.attributes.id;
  var tstart = timeExtent[0].unix() * 1000;
  var tend = timeExtent[1].unix() * 1000;
  Bokeh.index[plotID].model.x_range.start = tstart;
  Bokeh.index[plotID].model.x_range.end = tend;
}


// CONCATENATED MODULE: ./src/components/aeolian.js





function AddAeolian(map, layers) {
  var layer_json = {
    id: 'Aeolian',
    active: true,
    visibility: "visible",
    name: 'Aeolian transport',
    type: 'circle',
    icon: 'grain',
    clickable: true,
    source: {
      type: 'geojson',
      data: 'static/aeolian_data.geojson'
    },
    "info": "Processed data on aeolian sediment transport from the 6-week MegaPeX field campaign at the Sand Motor mega nourishment. <a href='https://data.4tu.nl/repository/uuid:3bc3591b-9d9e-4600-8705-5b7eba6aa3ed'  target='parent'>Data link</a>",
    paint: {
      // make circles larger as the user zooms from z12 to z22
      'circle-radius': {
        'base': 1.75,
        'stops': [[12, 2], [22, 80]]
      },
      'circle-color': ['match', ['get', 'deploymentName'], 'dn1', '#fbb03b', 'dn2', '#223b53', 'dn3', '#e55e5e', 'dn4', '#3bb2d0', 'dn5', '#956a37', 'dn6', '#8a5f2c', 'dn7', '#815726', 'dn8', '#724c20', 'dn9', '#66451f', 'dn10', '#2f1b02', 'dn11', '#201503', 'dn67', '#453c09',
      /* other */
      '#ccc']
    }
  };
  map.addLayer(layer_json);
  layers.push(layer_json);
  bus.$emit('select-layers', layers);
}

function filterAeolianBy(timeExtent, map) {
  //timeExtent provides 2 moments
  var tstart = timeExtent[0].unix();
  var tend = timeExtent[1].unix();
  var filters = ["all", ['>=', 'tStart', tstart], ['<=', 'tEnd', tend]];
  map.setFilter('Aeolian', filters);
}

function ShowAeolianData(point, div_id) {
  // todo check if multiple are selected; for now just select first
  var deploymentName = point.properties.deploymentName;
  var locationID = point.properties.location_ID;
  var timeEnd = moment_default.a.unix(parseFloat(point.properties.timeEnd));
  var timeStart = moment_default.a.unix(parseFloat(point.properties.timeStart));

  fetch("https://s3-eu-west-1.amazonaws.com/deltares-opendata/zandmotor/aeolian/aeolian_data_" + deploymentName + ".json").then(function (resp) {
    return resp.json();
  }).then(function (timeseries) {
    locationID = locationID;
    deploymentName = deploymentName;
    timeseries = timeseries;
    timeEnd = timeEnd.format('L');
    timeStart = timeStart.format('L');
    aeolian_bokehplot(locationID, deploymentName, timeseries, timeEnd, timeStart, point, div_id);
  }).catch(function (reason) {
    console.warn(reason);
  });
}

function aeolian_bokehplot(locationID, deploymentName, timeseries, timeEnd, timeStart, point, div_id) {

  // Check if timeseries is set
  if (timeseries == null) {
    console.log('No timeseries defined');
    return -1;
  }

  var div = document.getElementById(div_id);
  div.innerHTML = ""; // clear div

  // General Bokeh settings
  var plt = Bokeh.Plotting;
  var tools = "pan,crosshair,wheel_zoom,box_zoom,reset,save";

  // Get time slice
  var data = timeseries[deploymentName];
  var keys = keys_default()(data);

  // multiply by 1000 to convert to miliseconds
  var x = data[keys[0]];
  x = x.map(function (x) {
    return x * 1000;
  });

  // get deployment timeStart and timeEnd
  var deploymenttStart = moment_default.a.unix(parseFloat(x[0] / 1000)).format('L');
  var deploymenttEnd = moment_default.a.unix(parseFloat(x[x.length - 1] / 1000)).format('L');

  var plot = new plt.figure({
    title: "Deployment: " + deploymentName + " Location: " + locationID + " Start deployment: " + deploymenttStart + " End deployment: " + deploymenttEnd,
    tools: tools,
    width: 800,
    height: 350,
    x_axis_type: 'datetime',
    x_axis_label: 'Time',
    y_axis_label: 'Number of particles [-]',
    background_fill_color: "#F2F2F7"
  });

  // output linesegment per height
  var locationIDdata = data[locationID];
  var heights = keys_default()(locationIDdata);
  var colors = ["#666699", "#66ff66", "#ff6666"];

  for (var i = 0; i < heights.length; i++) {
    //y = y.slice(begin, end);

    // remove 0 values
    var filterFunction = function filterFunction(value, index, array) {
      return y[index] > 0;
    };

    var height = 'height ' + locationIDdata[heights[i]]['height'].toString() + ' m';
    var y = data[locationID][heights[i]]['particle_counts'];
    var xwithoutzero = x.filter(filterFunction);
    var ywithoutzero = y.filter(filterFunction);

    var source = new Bokeh.ColumnDataSource({
      data: {
        x: xwithoutzero,
        y: ywithoutzero
      }
    });

    var line = plot.line({ field: 'x' }, { field: 'y' }, { source: source, legend: height, line_color: colors[i], line_width: 2 });
  }

  plot._legend.location = 'top_left';
  var doc = new Bokeh.Document();
  doc.add_root(plot);
  Bokeh.embed.add_document_standalone(doc, div);
}


// CONCATENATED MODULE: ./src/components/drifters.js




function AddDrifters(map, layers) {
  var layer_json = {
    active: false,
    name: 'Drifters',
    icon: 'explore',
    id: 'Drifters',
    visibility: "visible",
    type: 'line',
    clickable: false,
    source: {
      type: 'geojson',
      data: 'https://s3-eu-west-1.amazonaws.com/deltares-opendata/zandmotor/drifters/drifters.geojson'
    },
    "info": "Drifter data as measured with GPS-tracked drifters during the megapex 2014 field campaign. Experiments have been done during ebb and flood and in a rip current. <a href='https://data.4tu.nl/repository/uuid:7f190c88-ae2e-43cf-959c-2b7d5c321573'  target='parent'>Data link</a>",
    paint: {
      'line-color': ['get', 'color'],
      'line-width': {
        'base': 4.0,
        'stops': [[12, 2], [22, 180]]
      }
    }
  };
  map.addLayer(layer_json);
  layers.push(layer_json);
  bus.$emit('select-layers', layers);
}

function filterDrifterBy(timeExtent, map) {
  //timeExtent provides 2 moments
  var tstart = timeExtent[0].unix();
  var tend = timeExtent[1].unix();
  var filters = ["all", ['>=', 'tStart', tstart], ['<=', 'tEnd', tend]];
  map.setFilter('Drifters', filters);
}


// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/mapbox-gl/dist/mapbox-gl.js
var mapbox_gl = __webpack_require__("1e2d");
var mapbox_gl_default = /*#__PURE__*/__webpack_require__.n(mapbox_gl);

// CONCATENATED MODULE: ./src/components/meteo.js



// import * as Bokeh from 'bokehjs'
// require.import('bokehjs') as Bokeh

// require('bokehjs')


function AddMeteo(map, layers) {
  fetch('static/wind_data.json').then(function (resp) {
    return resp.json();
  }).then(function (json) {
    addCanvas(json, layers, map);
    windsock(json);
  });
};

function ShowMeteoData(ids) {
  fetch("https://s3-eu-west-1.amazonaws.com/deltares-opendata/zandmotor/meteo/meteo_data_test1.json").then(function (resp) {
    return resp.json();
  }).then(function (json) {
    meteo_bokehplot("WindSpeed_Avg", document.getElementById(ids[0]), json);
    meteo_bokehplot("RelHumidity_Avg", document.getElementById(ids[1]), json);
  }).catch(function (reason) {
    console.warn(reason);
  });
};

function addCanvas(jsondata, layers, map) {
  var lat = jsondata.lat;
  var lon = jsondata.lon;
  var del = 0.003;
  var layer_json = defineProperty_default()({
    name: "Meteo",
    active: false,
    visibility: "none",
    id: 'Meteo',
    type: 'raster',
    clickable: true,
    paint: {
      'circle-radius': {
        'base': 1.2,
        'stops': [[12, 4], [22, 180]]
      },
      'circle-color': 'FireBrick'
    },
    icon: 'filter_drama',
    css: "",
    range: "",
    source: {
      type: 'canvas',
      animate: true,
      canvas: 'windsock-canvas',
      coordinates: [[lon - del, lat + del], [lon + del, lat + del], [lon + del, lat - del], [lon - del, lat - del]]
    },
    "info": "Meteo measurements at the Sand Motor. Air temperature, humidity, pressure, solar radiation, precipitation, wind speed and wind direction are measured. <a href='https://data.4tu.nl/repository/uuid:b7aac156-73d4-4b62-bad4-508c95de8331' target='parent'>Data link</a>"
  }, 'paint', {});
  map.addLayer(layer_json);
  layers.push(layer_json);
  bus.$emit('select-layers', layers);
};

function windsock(jsondata) {
  var t = 0;

  function draw() {
    var direc = jsondata.direc;
    var aspeed = jsondata.aspeed[t];
    var ctx = document.getElementById('windsock-canvas').getContext('2d');
    var w = 200;
    var h = 200;
    var bh = 70;
    var bw = 80;
    var c = 100;

    ctx.clearRect(0, 0, w, h);

    // shadow blur
    ctx.shadowColor = '#333';
    ctx.shadowBlur = 10;
    ctx.shadowOffsetX = 5;
    ctx.shadowOffsetY = 5;
    ctx.beginPath();
    ctx.arc(c, c, 10, 0, Math.PI * 2);
    ctx.fillStyle = "black";
    ctx.fill();

    ctx.closePath();
    ctx.beginPath();

    ctx.moveTo(bw, bh + 10);
    ctx.lineTo(c, c);
    ctx.lineTo(bw + 40, bh + 10);
    ctx.stroke();
    ctx.closePath();

    var bands = [[0, 80, bh, 40, 10, 'red'], [2, 80, bh - 10, 40, 10, 'white'], [4, 80, bh - 20, 40, 10, 'red'], [6, 80, bh - 30, 40, 10, 'white'], [8, 80, bh - 40, 40, 10, 'red']];
    var selectedBands = _.filter(bands, function (band) {
      var speed = band[0];
      return aspeed > speed;
    });
    _.each(selectedBands, function (band) {
      ctx.beginPath();
      ctx.fillStyle = band[5];
      ctx.rect(band[1], band[2], band[3], band[4]);
      ctx.fill();
      ctx.closePath();
    });

    ctx.translate(w / 2, h / 2);
    ctx.rotate(-(180 - direc[t - 1]) * (2 * Math.PI / 360));
    ctx.rotate((180 - direc[t]) * (2 * Math.PI / 360));
    ctx.translate(-w / 2, -h / 2);
    t += 1;

    var D = new Date(jsondata.time[t]);
    requestAnimationFrame(draw);
  }
  draw();
};

function meteo_bokehplot(data, div, meteodata) {
  var plt = Bokeh.Plotting;
  var tools = "pan,crosshair,wheel_zoom,box_zoom,reset,save";
  var begin = 0;
  var end = 100000;
  var y = meteodata[data].slice(begin, end);
  y = _.map(y, function (i) {
    if (i == -999) {
      return NaN;
    } else {
      return i;
    }
  });
  var x = [];
  _.each(meteodata.time.slice(begin, end), function (event) {
    x.push(new Date(event));
  });
  var source = new Bokeh.ColumnDataSource({
    data: {
      x: x,
      y: y
    }
  });

  // define ylabel based on source
  var ylabels = {};
  ylabels['RelHumidity_Avg'] = 'Relative Humidity [%]';
  ylabels['WindSpeed_Avg'] = 'Wind speed 44 m above surface [m/s]';
  var plot = new plt.figure({
    title: data,
    tools: tools,
    width: 1000,
    height: 350,
    x_axis_type: 'datetime',
    x_axis_label: 'Time',
    y_axis_label: ylabels[data],
    background_fill_color: "#F2F2F7"
  });

  var line = plot.line({ field: 'x' }, { field: 'y' }, { source: source, legend: data, line_color: "#666699", line_width: 2 });

  plot._legend.location = 'top_left';
  var doc = new Bokeh.Document();
  doc.add_root(plot);
  Bokeh.embed.add_document_standalone(doc, div);
}


// CONCATENATED MODULE: ./src/components/morphology.js



function AddMorphology(map, layers) {
  var layer_json = {
    "name": "Sediment Grain Size [µm]",
    "active": false,
    "visibility": "None",
    "icon": "grain",
    "id": "Sediment",
    "cursor": "crosshair",
    "type": "circle",
    "source": {
      "type": "geojson",
      "data": "static/sediment_data.geojson"
    },
    "range": "0  400",
    "css": "background: linear-gradient(to right, \
      hsla(0, 100%, 50%, 0.5), \
      rgba(255, 255, 0, 0.5));",
    "info": "Sediment sampling data from measurement campaign at the Sand Motor. <a href='https://data.4tu.nl/repository/uuid:598c390b-2368-4670-bc8c-d0b3ae09dd79' target='parent'>Data link</a>",
    paint: {
      "circle-color": {
        "base": 1,
        "type": "exponential",
        "property": "D50",
        "stops": [[0, "hsla(0, 100%, 50%, 0.5)"], [400, "rgba(255, 255, 0, 0.5)"]],
        "default": "hsl(0, 0%, 0%)"
      },
      "circle-stroke-width": 0.5
    }
  };
  map.addLayer(layer_json);
  layers.push(layer_json);
  bus.$emit('select-layers', layers);
  bus.$emit('add-legend', 'test');
}

function filterMorphologyBy(timeExtent, map) {
  //timeExtent provides 2 moments
  var tstart = timeExtent[0].unix();
  var tend = timeExtent[1].unix();
  var filters = ["all", ['>=', 'time', tstart], ['<=', 'time', tend]];
  map.setFilter('Sediment', filters);
}

// function ShowMorphologyData(data){
//    bokehplot(data, ddocument.getElementById("properties.id"))
//  }

//function bokehplot(data, div, meteodata) {
//  var plt = Bokeh.Plotting;
// var tools = "pan,crosshair,wheel_zoom,box_zoom,reset,save";
// var begin = 500000
// var end = 750000
// var y = meteodata[data].data.slice(begin, end)
// y = _.map(y, function(i) {
//   if (i >= 9.969209968386869e+36) {
//     return NaN
//   } else {
//     return i
//   }
// })
// var x = []
// _.each(meteodata.time.slice(begin, end), function(event) {
//   x.push(new Date(event))
// });
// var source = new Bokeh.ColumnDataSource({
//   data: {
//     x: x,
//     y: y
//   }
// });
//  var plot = new plt.figure({
//    // title: meteodata[data].title,
//    tools: tools,
//    width: 400,
//    height: 200,
//    x_axis_type: 'datetime',
//    background_fill_color: "#F2F2F7"
//  });
// var line = new Bokeh.Line({
//   x: {
//     field: "x"
//   },
//   y: {
//     field: "y"
//   },
//   line_color: "#666699",
//   line_width: 2
// });
//
// plot.add_glyph(line, source);
//  var doc = new Bokeh.Document();
//  doc.add_root(plot);
//  Bokeh.embed.add_document_standalone(doc, div);
//}


// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./src/app.js

























var app_draw = new mapbox_gl_draw({
  displayControlsDefault: false,
  controls: {
    line_string: true,
    trash: true
  }
});

/* harmony default export */ var app = ({
  name: 'app',
  data: function data() {
    return {
      map: null,
      drawer: true,
      fixed: false,
      showSettings: false,
      items: [{
        icon: 'bubble_chart',
        title: 'Inspire'
      }],
      layers: [],
      jsondata: "None",
      msg: "",
      timeExtent: [moment_default()("20110301", "YYYYMMDD"), moment_default()()],
      plots: [],
      draws: [],
      dialog: true
    };
  },
  watch: {
    dialog: {
      handler: function handler(dialog) {
        this.dialog = dialog;
      },
      deep: true
    }
  },

  mounted: function mounted() {
    var _this = this;

    bus.$on('change-dialog', function (dialog) {
      _this.dialog = dialog;
    });
    bus.$on('select-layers', function (layers) {
      vue_esm["a" /* default */].set(_this, 'layers', layers);
    });
    bus.$on('add-layer', function (layer) {
      _this.layers.push(layer);
    });
    bus.$on('add-card', function (card) {
      _this.plots.push(card);
    });

    bus.$on('click-plots', function (plots) {
      vue_esm["a" /* default */].set(_this, 'plots', plots);
    });
    bus.$on('map-loaded', function (event) {
      vue_esm["a" /* default */].set(_this, 'map', event.target);
    });

    this.$refs.timeslider.$on('time-extent-update', function (event) {
      _this.timeExtent = event;
      // check which layers are active
      var activeLayers = [];
      for (var i = 0; i < _this.layers.length; i++) {
        if (_this.layers[i].active) {
          activeLayers.push(_this.layers[i].id);
        }
      };
      // filter some map layers with filter options on time
      if (activeLayers.indexOf("Drifters") > -1) {
        filterDrifterBy(_this.timeExtent, _this.$refs.map.map);
      };
      if (activeLayers.indexOf("Aeolian") > -1) {
        filterAeolianBy(_this.timeExtent, _this.$refs.map.map);
      }
      if (activeLayers.indexOf("Sediment") > -1) {
        filterMorphologyBy(_this.timeExtent, _this.$refs.map.map);
      }
      if (activeLayers.indexOf("Jetski") > -1) {
        updateJetski(_this.$refs.map.map, _this.layers, _this.timeExtent[0], _this.timeExtent[1]);
      }
      DrawControls(_this.$refs.map.map, _this.draws, _this.timeExtent[0], _this.timeExtent[1], ['bathymetry_jetski', 'bathymetry_lidar']);

      // filter all open Bokeh plots on TimeSlider
      var keys = keys_default()(Bokeh.index);
      var tstart = _this.timeExtent[0].unix() * 1000;
      var tend = _this.timeExtent[1].unix() * 1000;
      for (var i = 0; i < keys.length; i++) {
        var array1 = Bokeh.index[keys[i]].model.attributes.renderers;
        if (array1.map(function (x) {
          return x.type;
        }).indexOf('DatetimeAxis') > 0) {
          // check if bokeh plot contains DatetimeAxis
          Bokeh.index[keys[i]].model.x_range.start = tstart;
          Bokeh.index[keys[i]].model.x_range.end = tend;
        }
      }
    });

    this.$refs.map.$on('mb-load', function (event) {
      bus.$emit('map-loaded', event);

      // Add different layers (Meteo, Morphology and Aeolian)
      _this.$refs.map.map.addControl(app_draw);

      AddMeteo(_this.$refs.map.map, _this.layers);
      AddMorphology(_this.$refs.map.map, _this.layers);
      AddAeolian(_this.$refs.map.map, _this.layers);
      AddDrifters(_this.$refs.map.map, _this.layers);
      // AddJetski(this.$refs.map.map, this.layers)
      AddLidar(_this.$refs.map.map, _this.layers);
      AddADCP(_this.$refs.map.map, _this.layers);
      updateJetski(_this.$refs.map.map, _this.layers);

      // TODO: Click event toevoegen
      _this.map.on('mousemove', function (e) {
        _this.$refs.map.map.getCanvas().style.cursor = '';
        var features = _this.map.queryRenderedFeatures(e.point);
        if (features[0] !== undefined) {
          var firstlayer = _this.layers.find(function (item) {
            return item.id === features[0].layer.id;
          });
          // Define pointer based on clickable layer
          if (firstlayer !== undefined && firstlayer.clickable) {
            _this.$refs.map.map.getCanvas().style.cursor = 'pointer';
          } else {
            _this.$refs.map.map.getCanvas().style.cursor = '';
          }
        }
      });
      _this.$refs.map.map.on('draw.create', function () {
        var regions = app_draw.getAll();
        var region = regions.features[regions.features.length - 1].geometry;
        var div_id = stringify_default()(region);
        _this.draws.push(region);
        _this.plots.push(div_id + '_bathymetry_jetski');
        _this.plots.push(div_id + '_bathymetry_lidar');
        bus.$emit('click-plots', _this.plots);
        DrawControls(_this.$refs.map.map, _this.draws, _this.timeExtent[0], _this.timeExtent[1], ['bathymetry_jetski', 'bathymetry_lidar']);
      });

      _this.map.on('click', function (e) {
        var click_lon = e.lngLat.lng;
        var click_lat = e.lngLat.lat;
        // WHen meteo-layer is visible and clicked on
        if (_this.map.getLayer('Meteo').visibility === 'visible') {
          var meteo = _this.layers.find(function (item) {
            return item.id === "Meteo";
          });
          var lon_min = meteo.source.coordinates[0][0];
          var lon_max = meteo.source.coordinates[1][0];
          var lat_min = meteo.source.coordinates[2][1];
          var lat_max = meteo.source.coordinates[0][1];
          if (click_lon <= lon_max && click_lat <= lat_max && click_lon >= lon_min && click_lat >= lat_min) {
            var ids = [];
            var params = ["WindSpeed_Avg", "RelHumidity_Avg"];
            _.each(params, function (p) {
              _this.plots.push(p);
              ids.push("plot_" + p);
              bus.$emit('click-plots', _this.plots);
            });
            ShowMeteoData(ids);
          }
        }

        // When clicked on a feature of Morphology or aeolian
        var features = _this.map.queryRenderedFeatures(e.point);
        _.each(features, function (point) {
          if (point.layer.id == "Sediment") {
            // var div_id = point.properties.id
            //this.plots.push(div_id)
            //bus.$emit('click-plots', this.plots);
            // ShowMorphologyData(point.properties, "plot_" + div_id)
          } else if (point.layer.id == "Aeolian") {
            var div_id = "Particle_" + point.properties.deploymentName + "_" + point.properties.location_ID;
            _this.plots.push(div_id);
            bus.$emit('click-plots', _this.plots);
            ShowAeolianData(point, "plot_" + div_id);
          } else if (point.layer.id == "ADCP") {
            var ids = [];
            var params = [point.properties.ADCPID + '_adcp-f-1', point.properties.ADCPID + '_adcp-f-2'];
            _.each(params, function (p) {
              _this.plots.push(p);
              ids.push("plot_" + p);
              bus.$emit('click-plots', _this.plots);
            });

            ShowADCPData(point, ids, _this.timeExtent);
          }
        });
      });
    });
  },

  methods: {
    removePlot: function removePlot(e) {
      var index = this.plots.indexOf(e);
      this.plots.splice(index, 1);
      bus.$emit('click-plots', this.plots);
    }
  },
  components: {
    'layer-control': components_LayerControl,
    'time-slider': components_TimeSlider,
    'v-welcome': components_VWelcome
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f80b6b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-navigation-drawer',{attrs:{"fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-flex',{attrs:{"xs2":"","offset-xs5":""}},[_c('v-tooltip',{attrs:{"fixed":"","bottom":""}},[(_vm.layers.length < 7)?_c('v-progress-circular',{attrs:{"slot":"activator","indeterminate":""},slot:"activator"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v("\r\n            Loading layers\r\n          ")])],1)],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('v-list-tile-title',{staticClass:"title"},[_vm._v("\r\n            Layers\r\n          ")])],1)],1)],1),_vm._v(" "),_c('layer-control',{attrs:{"layers":_vm.layers,"map":_vm.map}})],1),_vm._v(" "),_c('v-toolbar',{attrs:{"light":"","app":"","clipped":"","fixed":""}},[_c('v-toolbar-title',{staticClass:"ml-0 pl-3"},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v("\r\n      Zandmotor data\r\n    ")],1),_vm._v(" "),_c('time-slider',{ref:"timeslider",attrs:{"show-play":false}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-avatar',{attrs:{"width":"64px"}},[_c('a',{staticClass:"btn btn--flat btn--router",attrs:{"icon":"","large":"","href":"http://www.dezandmotor.nl/en/","target":"parent"}},[_c('img',{attrs:{"src":"static/images/NatureCoastLogo.png","alt":"Logo"}})])]),_vm._v(" "),_c('v-avatar',{attrs:{"size":"64px"}},[_c('a',{staticClass:"btn btn--flat btn--router",attrs:{"icon":"","large":"","href":"http://www.stw.nl/en","target":"parent"}},[_c('img',{attrs:{"src":"static/images/STWlogo.png","alt":"Logo"}})])]),_vm._v(" "),_c('v-avatar',{attrs:{"size":"64px"}},[_c('a',{staticClass:"btn btn--flat btn--router",attrs:{"icon":"","large":"","href":"https://github.com/openearth/sandmotor-viewer","target":"parent"}},[_c('img',{attrs:{"src":"static/images/GitHub-Mark.png","alt":"Logo"}})])]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:Arjen.Luijendijk@deltares.nlSubject=Contact%20Zandmotor%20data","target":"_top"}},[_vm._v("contact")]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticStyle:{"min-width":"30px"},attrs:{"slot":"activator","small":""},on:{"click":function($event){_vm.dialog=true}},slot:"activator"},[_c('v-icon',[_vm._v("fa-question")])],1),_vm._v(" "),_c('span',[_vm._v("Open the tutorial")])],1)],1),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"fluid":"","row":"","wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"sm12":"","mb-2":""}},[_c('v-card',{attrs:{"id":"map"}},[_c('v-card-text',[_c('v-mapbox',{ref:"map",attrs:{"access-token":"pk.eyJ1Ijoic2lnZ3lmIiwiYSI6Il8xOGdYdlEifQ.3-JZpqwUa3hydjAJFXIlMA","map-style":"mapbox://styles/mapbox/satellite-streets-v10","center":[4.186, 52.060],"zoom":12.5,"pitch":5.00,"bearing":-0,"min-zoom":5,"id":"map"}},[_c('canvas',{attrs:{"id":"windsock-canvas","width":"200","height":"200"}})])],1)],1)],1),_vm._v(" "),(_vm.plots.length < 1)?_c('v-card-text',[_c('p',[_vm._v("Graphs will be presented here after clicking on a layer with the icon "),_c('v-icon',[_vm._v("fa-area-chart")])],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.plots),function(plot){return _c('v-card',{key:plot,staticClass:"mb-1 mr-1",attrs:{"id":'card_'+ plot}},[_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","icon":""},on:{"click":function($event){_vm.removePlot(plot, $event)}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"plot-container bk-root",attrs:{"id":'plot_'+ plot}})])],1)})],2)],1)],1),_vm._v(" "),(_vm.dialog)?_c('v-welcome',{attrs:{"dialog":"dialog"}}):_vm._e()],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("Oqm7")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  app,
  App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.min.css
var vuetify_min = __webpack_require__("7zck");
var vuetify_min_default = /*#__PURE__*/__webpack_require__.n(vuetify_min);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command

// For IE compatability


// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






vue_esm["a" /* default */].use(vue2mapbox_gl_default.a);
vue_esm["a" /* default */].use(vuetify_default.a);



vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "Oqm7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k7bT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uS3p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uTBe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b662366b53c87fdef97d.js